import userReducer from './user'

const reducers = {
    userReducer: userReducer
  }
  
  export default reducers